module.exports = "import { Docs } from \"../../lib\";\nimport React from \"react\";\n\nexport default () => (\n  <Docs label=\"Demo\" description=\"I'm in a Showcase!\" />);\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/Docs/demo/NoProps.js
// module id = 130
// module chunks = 0